import React from 'react';

export default () => (
    <svg viewBox="0 0 100 100">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h86v86H0z" />
            <path
                d="M26.389 12v9h-11c-3.333 8.667-.667 15.667 8 21s18.667 7 30 5l6-26c-2 4-6.667 5-14 3s-13.667-6-19-12z"
                fill="#DECEFD"
            />
            <path
                d="M76 13L59 83M74.097 7.686a3.498 3.498 0 0 0 2.589 4.217 3.498 3.498 0 0 0 4.217-2.59 3.498 3.498 0 1 0-6.806-1.628zM68.875 43S61.499 35.236 48 37.849l5.422-22.66S66.012 8.605 75 18.272"
                stroke="#2A4473"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M54 37.095s-2.433 2.374-1.987 5.582c.446 3.206-15.209.838-27.693-9.875C11.837 22.087 3 27.744 3 27.744s6.823-12.03 14.973-10.831c-.806-1.856-3.415-6.062-10.296-8.54 0 0 15.978-10.064 30.177 4.576C48.401 23.825 52.158 16.5 52.158 16.5"
                stroke="#2A4473"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
